<app-breadcrumb [title]="'Elaborar'" [items]="['Extractos']" [active_item]="'Elaborar'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm">
    <!-- Header mejorado -->
    <div class="card-header bg-primary d-flex justify-content-between align-items-center py-3">
      <div class="d-flex align-items-center">
        <i class="icofont icofont-file-document fs-3 me-3 text-white"></i>
        <div>
          <h5 class="text-white mb-0"><strong>ELABORAR EXTRACTO</strong></h5>
          <small class="text-white opacity-75">Selecciona un vehículo para comenzar</small>
        </div>
      </div>
    </div>

    <div class="card-body p-3 p-md-4">
      <!-- Selector de placa mejorado -->
      <form [formGroup]="formNuevo">
        <div class="row g-3 mb-4">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="form-label" for="vehiculos">
             
              <strong>SELECCIONAR VEHÍCULO (PLACA)*:</strong>
            </label>
            <ng-select
              id="vehiculos"
              [items]="vehiculos"      
              bindLabel="placa"
              bindValue="placa"
              [searchable]="true"
              [clearable]="true"
              formControlName="placa"
              placeholder="Buscar por placa..."
              (change)="onPlacaSeleccionada($event)"
              class="custom-ng-select"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i class="icofont icofont-car-alt me-2 text-primary"></i>
                  <strong>{{ item.placa }}</strong>
                  <span class="ms-2 badge bg-primary text-white">{{ item.relacion }}</span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ item.placa }}</strong>
                    <small class="d-block text-primary">{{ item.relacion }}</small>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </form>

      <!-- Indicador de carga mientras se consulta la información -->
      <div *ngIf="cargandoVehiculo" class="text-center py-5">
        <div class="card border-0 bg-light py-5">
          <div class="card-body">
            <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <h5 class="text-dark mt-4 mb-2"><strong>Cargando información del vehículo...</strong></h5>
            <p class="text-muted small mb-0">
              <i class="icofont icofont-search me-1"></i>
              Consultando documentos y conductores
            </p>
          </div>
        </div>
      </div>

      <!-- Contenido cuando hay vehículo seleccionado -->
      <div *ngIf="vehiculoSeleccionado && !cargandoVehiculo">

        <!-- Documentos del Vehículo -->
         
        <div class="row g-3 mb-4">
          
<div class="col-12 col-lg-6">
  <div class="card documentos-vehiculo-card border-0 shadow-sm h-100">

    <!-- Encabezado -->
    <div class="card-header bg-primary text-white d-flex align-items-center py-3">
      <i class="icofont icofont-file-text fs-4 me-3"></i>

      <div>
        <h6 class="mb-0 fw-bold">DOCUMENTOS DEL VEHÍCULO</h6>
        <small class="opacity-75">
          Estado de vigencia y próximos vencimientos
        </small>
      </div>
    </div>

    <div class="card-body p-0">

      <!-- Vista móvil -->
      <div class="d-lg-none documentos-mobile">
        <div class="p-3">

          <!-- Tarjeta de operación -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.tarjetaOperacion?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.tarjetaOperacion?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.tarjetaOperacion?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-file-text"></i>
              </div>

              <div class="documento-descripcion">
                <strong>TARJETA DE OPERACIÓN</strong>
                <small>Permiso de operación del vehículo</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>
                    {{ vehiculoSeleccionado?.tarjetaOperacion?.fecha | date:'dd/MM/yyyy' }}
                  </strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.tarjetaOperacion?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.tarjetaOperacion?.estado)">
                {{ vehiculoSeleccionado?.tarjetaOperacion?.estado }}
              </span>
            </div>
          </div>

          <!-- SOAT -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.soat?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.soat?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.soat?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-shield"></i>
              </div>

              <div class="documento-descripcion">
                <strong>SOAT</strong>
                <small>Seguro Obligatorio de Accidentes de Tránsito</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.soat?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.soat?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.soat?.estado)">
                {{ vehiculoSeleccionado?.soat?.estado }}
              </span>
            </div>
          </div>

          <!-- RTM -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.cda?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.cda?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.cda?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-gear"></i>
              </div>

              <div class="documento-descripcion">
                <strong>RTM</strong>
                <small>Revisión Técnico Mecánica</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.cda?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.cda?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.cda?.estado)">
                {{ vehiculoSeleccionado?.cda?.estado }}
              </span>
            </div>
          </div>

          <!-- Revisión bimestral -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.revisionBimestral?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.revisionBimestral?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.revisionBimestral?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-checked"></i>
              </div>

              <div class="documento-descripcion">
                <strong>REVISIÓN BIMESTRAL</strong>
                <small>Revisión de seguridad</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.revisionBimestral?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.revisionBimestral?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.revisionBimestral?.estado)">
                {{ vehiculoSeleccionado?.revisionBimestral?.estado }}
              </span>
            </div>
          </div>

          <!-- Pólizas RCC -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.contractual?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.contractual?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.contractual?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-file-text"></i>
              </div>

              <div class="documento-descripcion">
                <strong>PÓLIZAS RCC</strong>
                <small>Responsabilidad Civil Contractual</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.contractual?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.contractual?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.contractual?.estado)">
                {{ vehiculoSeleccionado?.contractual?.estado }}
              </span>
            </div>
          </div>

          <!-- Pólizas RCE -->
          <div class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.extracontractual?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.extracontractual?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.extracontractual?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-file-text"></i>
              </div>

              <div class="documento-descripcion">
                <strong>PÓLIZAS RCE</strong>
                <small>Responsabilidad Civil Extracontractual</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.extracontractual?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.extracontractual?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.extracontractual?.estado)">
                {{ vehiculoSeleccionado?.extracontractual?.estado }}
              </span>
            </div>
          </div>

          <!-- Convenio -->
          <div *ngIf="vehiculoSeleccionado?.relacion?.id === 8"
            class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.convenio?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.convenio?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.convenio?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-file-text"></i>
              </div>

              <div class="documento-descripcion">
                <strong>Convenio</strong>
                <small>Vigencia del convenio</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Vence el</small>
                  <strong>{{ vehiculoSeleccionado?.convenio?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ vehiculoSeleccionado?.convenio?.diasRestantes }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.convenio?.estado)">
                {{ vehiculoSeleccionado?.convenio?.estado }}
              </span>
            </div>
          </div>

          <!-- Alistamiento diario -->
          <div *ngIf="validarPreoActivo()"
            class="documento-item"
            [ngClass]="{
              'documento-vigente': vehiculoSeleccionado?.ultimoAlistamiento?.estado === 'VIGENTE',
              'documento-proximo': vehiculoSeleccionado?.ultimoAlistamiento?.estado === 'PROXIMO A VENCER',
              'documento-vencido': vehiculoSeleccionado?.ultimoAlistamiento?.estado === 'VENCIDO'
            }">

            <div class="documento-item-superior">
              <div class="documento-icono">
                <i class="icofont icofont-checked"></i>
              </div>

              <div class="documento-descripcion">
                <strong>Alistamientos diarios</strong>
                <small>Control de alistamiento del vehículo</small>
              </div>
            </div>

            <div class="documento-item-inferior">
              <div class="documento-fecha">
                <i class="icofont icofont-calendar"></i>
                <div>
                  <small>Fecha de referencia</small>
                  <strong>{{ vehiculoSeleccionado?.ultimoAlistamiento?.fecha | date:'dd/MM/yyyy' }}</strong>
                </div>
              </div>

              <div class="documento-dias">
                <strong>{{ getDiasAlistamiento(vehiculoSeleccionado?.ultimoAlistamiento) }}</strong>
                <small>días</small>
              </div>

              <span class="badge"
                [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.ultimoAlistamiento?.estado)">
                {{ vehiculoSeleccionado?.ultimoAlistamiento?.estado }}
              </span>
            </div>
          </div>

        </div>
      </div>

      <!-- Vista escritorio -->
      <div class="d-none d-lg-block table-responsive">
        <table class="table table-hover table-sm mb-0 tabla-documentos">
          <thead class="table-light">
            <tr>
              <th>DOCUMENTO</th>
              <th class="text-center">VENCIMIENTO</th>
              <th class="text-center">DÍAS</th>
              <th class="text-center">ESTADO</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td><strong>TARJETA DE OPERACIÓN</strong></td>
              <td class="text-center">
                {{ vehiculoSeleccionado?.tarjetaOperacion?.fecha | date:'dd/MM/yyyy' }}
              </td>
              <td class="text-center">
                {{ vehiculoSeleccionado?.tarjetaOperacion?.diasRestantes }}
              </td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.tarjetaOperacion?.estado)">
                  {{ vehiculoSeleccionado?.tarjetaOperacion?.estado }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>SOAT</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.soat?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.soat?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.soat?.estado)">
                  {{ vehiculoSeleccionado?.soat?.estado }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>REVISIÓN TECNOMECÁNICA</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.cda?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.cda?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.cda?.estado)">
                  {{ vehiculoSeleccionado?.cda?.estado }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>REVISIÓN BIMESTRAL</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.revisionBimestral?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.revisionBimestral?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.revisionBimestral?.estado)">
                  {{ vehiculoSeleccionado?.revisionBimestral?.estado }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>PÓLIZAS RCC</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.contractual?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.contractual?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.contractual?.estado)">
                  {{ vehiculoSeleccionado?.contractual?.estado }}
                </span>
              </td>
            </tr>

            <tr>
              <td><strong>PÓLIZAS RCE</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.extracontractual?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.extracontractual?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.extracontractual?.estado)">
                  {{ vehiculoSeleccionado?.extracontractual?.estado }}
                </span>
              </td>
            </tr>

            <tr *ngIf="vehiculoSeleccionado?.relacion?.id === 8">
              <td><strong>CONVENIO</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.convenio?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ vehiculoSeleccionado?.convenio?.diasRestantes }}</td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.convenio?.estado)">
                  {{ vehiculoSeleccionado?.convenio?.estado }}
                </span>
              </td>
            </tr>

            <tr *ngIf="validarPreoActivo()">
              <td><strong>ALISTAMIENTOS DIARIOS</strong></td>
              <td class="text-center">{{ vehiculoSeleccionado?.ultimoAlistamiento?.fecha | date:'dd/MM/yyyy' }}</td>
              <td class="text-center"
                [class.text-danger]="vehiculoSeleccionado?.ultimoAlistamiento?.estado === 'VENCIDO'">
                {{ getDiasAlistamiento(vehiculoSeleccionado?.ultimoAlistamiento) }}
              </td>
              <td class="text-center">
                <span class="badge"
                  [ngClass]="getEstadoColorDocu(vehiculoSeleccionado?.ultimoAlistamiento?.estado)">
                  {{ vehiculoSeleccionado?.ultimoAlistamiento?.estado }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>


          <!-- Conductores -->
          <div class="col-12 col-lg-6">
            <div class="card-header bg-primary text-white d-flex align-items-center py-3">
      <i class="icofont icofont-file-text fs-4 me-3"></i>

      <div>
        <h6 class="mb-0 fw-bold">CONDUCTORES DEL VEHÍCULO</h6>
        <small class="opacity-75">
          Estado de vigencia y próximos vencimientos
        </small>
      </div>
    </div>
            <div class="card border-0 shadow-sm">
              
              <div class="card-body p-0">
                <!-- Vista Mobile: Cards -->
                <div class="d-lg-none p-3">
                  <div *ngFor="let conductor of vehiculoSeleccionado?.conductores | paginate: { itemsPerPage: pageSize1, currentPage: page1 }" 
                       class="card mb-3 border-start border-primary border-3">
                    <div class="card-body p-2">
                      <h6 class="text-uppercase mb-2">
                        {{ conductor.propietario?.primernombre }} {{ conductor.propietario?.segundonombre }}
                        {{ conductor.propietario?.papellidos }} {{ conductor.propietario?.seapellidos }}
                      </h6>
                      <div class="row g-2 small">
                        <div class="col-6">
                          <strong>Cédula:</strong><br>
                          {{ conductor.conductor_id }}
                        </div>
                        <div class="col-6">
                          <strong>Licencia:</strong><br>
                          {{ conductor.propietario?.numerolic }}
                        </div>
                        <div class="col-12">
                          <strong>Vence Licencia:</strong><br>
                          <span class="badge" [ngClass]="getEstadoColor(getEstadoLicencia(conductor.propietario?.vencelic))">
                            {{ conductor.propietario?.vencelic ? (conductor.propietario?.vencelic | date:'dd/MM/yyyy') : 'Sin fecha' }}
                          </span>
                        </div>
                        <div class="col-12">
                          <strong>Seguridad Social:</strong><br>
                          <span class="badge" [ngClass]="getEstadoColor(getEstadoLicencia(conductor.propietario?.fechacobeps))">
                            {{ conductor.propietario?.fechacobeps ? (conductor.propietario?.fechacobeps | date:'dd/MM/yyyy') : 'Sin fecha' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Vista Desktop: Table -->
                <div class="d-none d-lg-block table-responsive">
                  <table class="table table-hover table-sm mb-0">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center"><strong>CÉDULA</strong></th>
                        <th class="text-center"><strong>CONDUCTOR</strong></th>
                        <th class="text-center"><strong>LICENCIA</strong></th>
                        <th class="text-center"><strong>VENCE</strong></th>
                        <th class="text-center"><strong>SEG. SOCIAL</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let conductor of vehiculoSeleccionado?.conductores | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                        <td class="text-center">{{ conductor.conductor_id }}</td>
                        <td class="text-uppercase text-center">
                          {{ conductor.propietario?.primernombre }}
                          {{ conductor.propietario?.segundonombre }}
                          {{ conductor.propietario?.papellidos }}
                          {{ conductor.propietario?.seapellidos }}
                        </td>
                        <td class="text-center">{{ conductor.propietario?.numerolic }}</td>
                        <td class="text-center">
                          <span class="badge" [ngClass]="getEstadoColor(getEstadoLicencia(conductor.propietario?.vencelic))">
                            {{ conductor.propietario?.vencelic ? (conductor.propietario?.vencelic | date:'dd/MM/yyyy') : 'Sin fecha' }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span class="badge" [ngClass]="getEstadoColor(getEstadoLicencia(conductor.propietario?.fechacobeps))">
                            {{ conductor.propietario?.fechacobeps ? (conductor.propietario?.fechacobeps | date:'dd/MM/yyyy') : 'Sin fecha' }}
                          </span>
                        </td>
                      </tr>
                      <tr *ngIf="conductoresFiltrados && conductoresFiltrados.length === 0">
                        <td class="text-center text-warning" colspan="5">
                          {{ mensajeBusqueda || 'No se encontraron resultados.' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Paginación -->
                <div *ngIf="conductoresFiltrados?.length > 0" class="p-3 border-top">
                  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                    <div class="d-flex align-items-center">
                      <label for="pageSize1" class="me-2 small">Mostrar:</label>
                      <select id="pageSize1" class="form-select form-select-sm" style="width: auto;" [(ngModel)]="pageSize1" (change)="page1 = 1">
                        <option *ngFor="let size1 of [5, 10, 20, 50]" [value]="size1">{{ size1 }}</option>
                      </select>
                    </div>

                    <span class="badge bg-primary">
                      Total: {{ conductoresFiltrados?.length || 0 }} conductor(es)
                    </span>

                    <pagination-controls (pageChange)="page1 = $event" [maxSize]="3" [directionLinks]="true" [autoHide]="true"
                      previousLabel="Anterior" nextLabel="Siguiente">
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Fecha máxima y botón de acción -->
     
<div class="row g-3 mt-2">
  <div class="col-12">

    <!-- Fecha máxima -->
    <div
      *ngIf="vehiculoSeleccionado?.fechamax"
      class="fecha-maxima-card mb-4">

      <div class="fecha-maxima-icono">
        <i class="icofont icofont-ui-calendar"></i>
      </div>

      <div class="fecha-maxima-info">
        <span class="fecha-maxima-titulo">
          FECHA MÁXIMA PARA ELABORAR EXTRACTO
        </span>

        <span class="fecha-maxima-valor">
          {{ vehiculoSeleccionado?.fechamax | date:'dd/MM/yyyy' }}
        </span>
      </div>
    </div>

    <!-- Acción principal -->
    <div class="text-center">
      <button
        *ngIf="datosListos && hayConductoresVigentes"
        type="button"
        class="btn btn-realizar-extracto"
        (click)="crearExtracto()">

        <i class="icofont icofont-file-document me-2"></i>
        REALIZAR EXTRACTO
        <i class="fa fa-arrow-right ms-2"></i>
      </button>
    </div>

  </div>
</div>

      </div>

      <!-- Mensaje cuando no hay vehículo seleccionado -->
      <div *ngIf="!vehiculoSeleccionado && !cargandoVehiculo" class="text-center py-5">
        <div class="card border-0 bg-light py-5">
          <div class="card-body">
            <i class="icofont icofont-vehicle-delivery-van text-primary" style="font-size: 6rem; opacity: 0.8;"></i>
            <h4 class="text-dark mt-4 mb-2"><strong>¡Comienza aquí!</strong></h4>
            <h5 class="text-dark">Selecciona un vehículo para ver sus documentos y conductores</h5>
            <p class="text-dark small mt-3 mb-0">
              <i class="icofont icofont-hand-up me-1"></i>
              Usa el selector de arriba para buscar por placa
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>